// @ts-ignore
import ReactPdfViewer from "components/shared-components/ReactPdfViewer";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
// @ts-ignore
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { downloadFile, getCapcha, getSearchResult } from "store/portal/actions";
import "./style.scss";

const ResultSearch = props => {
  const {
    isOpenModal,
    toggleModal,
    pdf,
    dataVerity,
    handleCloseModel,
    dataSearch,
  } = props;
  const [fileDownload, setFileToDownload] = useState([]);
  const [options, setOptionsSelect] = useState([]);
  const dispatch = useDispatch();
  // @ts-ignore
  const { t, i18n } = useTranslation(["businessUnit"]);
  const { addToast } = useToasts();
  // @ts-ignore
  const [dataInfoState, setDataInfo] = useState({
    name: "",
    KHHDon: "",
    NLap: "",
    NBKe: "",
    MSTTCGP: "",
    MST: "",
  });
  // @ts-ignore
  const Portal = useSelector(state => state.Portal);
  // @ts-ignore
  const { loading, resultDownload, loadingDownload, loadingResult } = Portal;
  const downloadFileFunc = type => {
    if (fileDownload) {
      dispatch(
        downloadFile({
          ids: fileDownload,
          file_type: type,
          token: dataVerity.token,
        })
      );
    }
  };
  function parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }
  const checkExpireInvoice = () => {
    return parseInt(Date.now()) >
      parseInt(
        dataSearch &&
          dataSearch.dataSign &&
          dataSearch.dataSign.ca?.signing_time
      )
      ? false
      : true;
  };
  // useEffect(() => {
  //   var xml = base64toBlob(dataSearch.dataXML);
  //   if (xml) {
  //     var parser = new DOMParser();
  //     var xmlDoc = parser.parseFromString(xml, "text/xml");
  //     const dataInfo = {
  //       name: xmlDoc.getElementsByTagName("Ten")[0].childNodes[0].nodeValue,
  //       KHHDon: xmlDoc.getElementsByTagName("THDon")[0].childNodes[0].nodeValue,
  //       NLap: xmlDoc.getElementsByTagName("NLap")[0].childNodes[0].nodeValue,
  //       NBKe: xmlDoc.getElementsByTagName("NBKe")[0].childNodes[0].nodeValue,
  //       MSTTCGP:
  //         xmlDoc.getElementsByTagName("MSTTCGP")[0].childNodes[0].nodeValue,
  //       MST: xmlDoc.getElementsByTagName("MST")[0].childNodes[0].nodeValue,
  //     };
  //     setDataInfo(dataInfo);
  //   }
  // }, [dataSearch]);
  useEffect(() => {
    if (resultDownload && resultDownload.success) {
      downloadFunc(resultDownload.data);
    }
  }, [resultDownload]);
  const checkMST = (MSTEsign, MSTTC) => {
    return MSTEsign == MSTTC;
  };
  function b64DecodeUnicode(str) {
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  }
  const base64toBlob = data => {
    if (data) {
      const base64WithoutPrefix = data.substr(
        "data:application/xml;base64,".length
      );
      return b64DecodeUnicode(base64WithoutPrefix);
    }
  };
  const checkToken = token => {
    const expireToken = parseJwt(token).exp;
    if (parseInt(Date.now()) > parseInt(expireToken) * 1000) {
      return false;
    } else {
      return true;
    }
  };
  const closeModelExpried = () => {
    addToast("Đã hết phiên làm việc, vui lòng tra cứu lại", {
      appearance: "warning",
      autoDismiss: true,
    });
    handleCloseModel();
    dispatch(getCapcha());
  };
  const downloadFunc = data => {
    if (dataVerity && dataVerity.token) {
      if (checkToken(dataVerity.token) && data) {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.zip");
        document.body.appendChild(link);
        link.click();
      } else {
        closeModelExpried();
      }
    }
  };
  useEffect(() => {
    var option = [];
    var filesDownload = [];
    if (dataVerity) {
      dataVerity.model &&
        dataVerity.model.length > 0 &&
        dataVerity.model.map(item => {
          filesDownload.push(item.id);
          setFileToDownload(filesDownload);
          option.push({
            value: item.id,
            label: item.filename,
          });
          setOptionsSelect(option);
        });
    }
  }, [dataVerity]);
  const setSelectedPDF = e => {
    if (e && dataVerity) {
      if (checkToken(dataVerity.token)) {
        dispatch(
          getSearchResult({
            id: e.value,
            token: dataVerity.token,
          })
        );
      } else {
        closeModelExpried();
      }
    }
  };
  // @ts-ignore
  return (
    <Modal
      size="lg"
      isOpen={isOpenModal}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal modal-pdf"
      toggle={toggleModal}
    >
      <div className="modal-content model-body-pdf">
        <ModalHeader toggle={toggleModal}>Kết quả tra cứu</ModalHeader>
        {/* <div
          className="app-search"
          style={{ maxWidth: "200px", marginLeft: "15px", zIndex: 1111 }}
        >
          <Select
            placeholder="Chọn tệp PDF"
            defaultValue={options[0]}
            isDisabled={loadingResult}
            onChange={e => {
              setSelectedPDF(e);
            }}
            options={options}
            classNamePrefix="select2-selection"
          />
        </div> */}

        <React.Fragment>
          <ModalBody>
            <div className="row">
              {/* <div className="col-8 col-sm-4 hr-body-pdf">
                <div className="file-info">
                  <h5 className="font-weight-semibold">Thông tin chữ ký số</h5>
                  {loadingResult ? (
                    <ModalBody>
                      <div className="d-flex justify-content-center align-items-center loading-result-info">
                        {" "}
                        <div
                          className="spinner-grow spinner-border-sm mx-2"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    </ModalBody>
                  ) : (
                    <div>
                      <p className="info-text">
                        <i className="fas fa-check-circle icon-confirm-info"></i>
                        Ký bởi doanh nghiệp :{" "}
                        {dataSearch &&
                          dataSearch.dataSign &&
                          dataSearch.dataSign.ca?.company_name}
                      </p>
                      <p className="info-text">
                        <i className="fas fa-check-circle icon-confirm-info"></i>
                        Số serial :{" "}
                        {dataSearch &&
                          dataSearch.dataSign &&
                          dataSearch.dataSign.ca?.serial_num}
                      </p>
                      <p className="info-text">
                        <i className="fas fa-check-circle icon-confirm-info"></i>
                        Nhà cung cấp CA :{" "}
                        {dataSearch &&
                          dataSearch.dataSign &&
                          dataSearch.dataSign.ca?.ten}
                      </p>
                      <p className="info-text">
                        <i className="fas fa-check-circle icon-confirm-info"></i>
                        Thời gian hiệu lực : từ ngày{" "}
                        {moment(
                          dataSearch &&
                            dataSearch.dataSign &&
                            dataSearch.dataSign.ca?.issued_time
                        ).format("DD/MM/YYYY")}{" "}
                        đến ngày{" "}
                        {moment(
                          dataSearch &&
                            dataSearch.dataSign &&
                            dataSearch.dataSign.ca?.expired_time
                        ).format("DD/MM/YYYY")}
                      </p>
                      <p className="info-text">
                        <i className="fas fa-check-circle icon-confirm-info"></i>
                        Trạng thái chữ ký :{" "}
                        {dataSearch &&
                        dataSearch.dataSign &&
                        dataSearch.dataSign.ca?.status
                          ? "Còn hiệu lực"
                          : "Hết hiệu lực"}
                      </p>
                    </div>
                  )}
                </div>
                <div className="file-info">
                  <h5 className="font-weight-semibold">Kết quả kiểm tra</h5>
                  {loadingResult ? (
                    <ModalBody>
                      <div className="d-flex justify-content-center align-items-center loading-result-info">
                        {" "}
                        <div
                          className="spinner-grow spinner-border-sm mx-2"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    </ModalBody>
                  ) : (
                    <div>
                      <p className="info-text">
                        {checkMST(
                          dataSearch && dataSearch.dataSign?.mst,
                          dataInfoState.MST
                        ) ? (
                          <React.Fragment>
                            <i className="fas fa-check-circle icon-confirm-info"></i>
                            <span>
                              MST đơn vị phát hành trùng với MST trên chữ ký số
                            </span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <i className="fas fa-ban icon-confirm-info-ban"></i>
                            <span>
                              MST đơn vị phát hành không trùng với MST trên chữ
                              ký số
                            </span>
                          </React.Fragment>
                        )}
                      </p>
                      <p className="info-text">
                        <i className="fas fa-check-circle icon-confirm-info"></i>
                        Thời điểm ký :{" "}
                        {moment(
                          dataSearch &&
                            dataSearch.dataSign &&
                            dataSearch.dataSign?.signing_time
                        ).format("DD/MM/YYYY")}
                      </p>
                      <p className="info-text">
                        {checkExpireInvoice() ? (
                          <i className="fas fa-check-circle icon-confirm-info"></i>
                        ) : (
                          <i className="fas fa-ban icon-confirm-info-ban"></i>
                        )}
                        {checkExpireInvoice()
                          ? "Chữ ký số còn hiệu lực đến thời điểm hiện tại"
                          : "Chữ ký số hết hiệu lực đến thời điểm hiện tại"}
                      </p>
                    </div>
                  )}
                </div>
              </div> */}
              <div className="col-12 col-sm-12">
                {loadingResult ? (
                  <ModalBody>
                    <div className="d-flex justify-content-center align-items-center loading-result-pdf">
                      {" "}
                      <div
                        className="spinner-grow spinner-border-sm mx-2"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  </ModalBody>
                ) : (
                  <ReactPdfViewer filePdfUrl={pdf} style={{ height: "75vh" }} />
                )}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            {/* <div className="text-alight">Số HD</div> */}
            <div className="justify-content-end d-flex">
              <button
                onClick={() => downloadFileFunc("pdf")}
                className="mx-2 btn btn-primary btn-block d-flex justify-content-center align-items-center"
                type="submit"
                disabled={loadingDownload}
              >
                Tải xuống PDF
              </button>
              <button
                onClick={() => downloadFileFunc("xml")}
                className="mx-2 btn btn-primary btn-block d-flex justify-content-center align-items-center"
                type="submit"
                disabled={loadingDownload}
              >
                Tải xuống XML
              </button>
            </div>
          </ModalFooter>
        </React.Fragment>
      </div>
    </Modal>
  );
};

ResultSearch.propTypes = {
  dataSearch: PropTypes.object.isRequired,
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleCloseModel: PropTypes.func.isRequired,
  pdf: PropTypes.string.isRequired,
  dataVerity: PropTypes.object.isRequired,
};

ResultSearch.defaultProps = {
  userBusinessUnit: {},
  dataVerity: {},
  isOpenModal: false,
  pdf: "",
  dataSearch: {
    dataSign: {
      ca: {},
    },
  },
};

export default ResultSearch;
